import { createSelector } from 'reselect';
import { ClientReducerState } from 'client/reducers';

export const selectCard = (state: ClientReducerState) => state.card;

export const selectCardElements = createSelector(selectCard, card => card.elements);
